import { getStore } from './storeRegistry';
/**
 * Wrapper for fetch that automatically adds JWT token from authSlice to requests.
 * This is a shared utility that works with the lazy-loaded authSlice.
 *
 * @param input - Request URL or Request object
 * @param init - Fetch options (will be merged with auth headers)
 * @returns Promise<Response>
 *
 * @example
 * ```typescript
 * import { fetchAuthWrapper } from '@starjack/api';
 *
 * const response = await fetchAuthWrapper('/api/users', {
 *   method: 'GET',
 * });
 * ```
 */
export const fetchAuthWrapper = async (input, init = {}) => {
    const store = getStore();
    const state = store.getState();
    const jwt = state?.authSlice?.jwt;
    // For FormData bodies the browser must set Content-Type itself so the
    // multipart boundary is included; forcing application/json breaks the upload.
    const isFormData = typeof FormData !== 'undefined' && init.body instanceof FormData;
    const headers = {
        Accept: 'application/json',
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        ...init.headers,
    };
    if (jwt) {
        headers.Authorization = `bearer ${jwt}`;
    }
    const response = await fetch(input, {
        ...init,
        headers,
    });
    return response;
};
